export default __webpack_public_path__ + "static/media/632.6153d07c.jpg";